import actionTypes from '../constants/action-types';

const addCustomFontPair = (fontPair) => ({
  type: actionTypes.ADD_CUSTOM_FONT_PAIR,
  payload: {
    fontPair,
  },
});

export default addCustomFontPair;
